import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { AdCampaignWizard } from '@/components/mediaBuying/adCampaign/AdCampaignWizard'
import { CubeLoader } from '@/components/ui/cube-loader'
import { GET_AD_CAMPAIGN_FOR_EDIT } from '@/graphql/ads/ad-campaigns-queries'
import { useHypothesisLabels } from './utils/useHypothesisLabels'
import { buildAdCampaignEditWizardInitialState } from './utils/adCampaignEditWizardInitialState'

const EditAdSet = () => {
    const { adCampaignId, adSetId } = useParams()

    const { data, loading, error } = useQuery(GET_AD_CAMPAIGN_FOR_EDIT, {
        variables: { adCampaignId },
        skip: !adCampaignId,
    })

    const { labels: hypothesisLabels, loading: labelsLoading } = useHypothesisLabels(
        data?.AdCampaign?.adCampaignForEdit?.ad_sets,
    )

    if (loading || labelsLoading) {
        return (
            <div className="tw:w-full tw:flex tw:items-center tw:justify-center tw:h-full">
                <CubeLoader size="default" fullScreen={true} />
            </div>
        )
    }

    if (error || !data?.AdCampaign?.adCampaignForEdit) {
        return (
            <div className="tw:w-full tw:flex tw:items-center tw:justify-center tw:h-full">
                <p className="tw:text-red-400">Failed to load campaign data.</p>
            </div>
        )
    }

    const campaignData = data.AdCampaign.adCampaignForEdit
    const wizardInitialState = buildAdCampaignEditWizardInitialState(campaignData, {
        filterAdSetId: adSetId,
        hypothesisLabels,
    })

    if (!wizardInitialState) {
        return (
            <div className="tw:w-full tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-full tw:gap-2">
                <p className="tw:text-red-400">Ad set not found in this campaign.</p>
            </div>
        )
    }

    const singleExternalId = wizardInitialState.contentCache?.prefetchedData?.singleAdSetExternalId

    return (
        <div className="tw:flex tw:flex-col tw:h-full tw:w-full">
            {!singleExternalId && (
                <div
                    className="tw:shrink-0 tw:mx-6 tw:mt-4 tw:rounded-md tw:border tw:border-amber-600/50 tw:bg-amber-950/40 tw:px-4 tw:py-3 tw:text-sm tw:text-amber-100"
                    role="status"
                >
                    This ad set is not linked to Meta yet. Saving will update your draft in Turba Media only; budget and
                    targeting will sync once the ad set is published.
                </div>
            )}
            <div className="tw:flex-1 tw:min-h-0">
                <AdCampaignWizard
                    isEditMode
                    isEditAdSetMode
                    adCampaignId={adCampaignId}
                    adSetId={adSetId}
                    editInitialState={wizardInitialState}
                />
            </div>
        </div>
    )
}

export default EditAdSet
